import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const BASE_PATH_CATEGORY=BASE_PATH+'/category'
const dataManagement: Array<RouteConfig> = [
    {
        path: 'data-manage',
        name: 'dataManagement',
        redirect: { name: 'cropper' },
        meta: {
            menuMatch: 'dataManagement',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            //农作物
            {
                path: 'cropper',
                name: 'cropper',
                component: () => import(`@/${BASE_PATH_CATEGORY}/cropper/Cropper.vue`),
                meta: {
                    index: '1-1',
                },
            },
            {
                path: 'cropper-large',
                name: 'cropperLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-1',
                    type:'农作物',
                    routerBack:'cropper'
                },
            },

            // 药品
            {
                path: 'pharmaceuticals',
                name: 'pharmaceuticals',
                component: () => import(`@/${BASE_PATH_CATEGORY}/pharmaceuticals/Pharmaceuticals.vue`),
                meta: {
                    index: '1-2',
                },
            },
            {
                path: 'pharmaceuticals-large',
                name: 'pharmaceuticalsLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-2',
                    type:'药品',
                    routerBack:'pharmaceuticals'
                },
            },

            // 肥料
            {
                path: 'manure',
                name: 'manure',
                component: () => import(`@/${BASE_PATH_CATEGORY}/manure/Manure.vue`),
                meta: {
                    index: '1-3',
                },
            },
            {
                path: 'manure-large',
                name: 'manureLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-3',
                    type:'肥料',
                    routerBack:'manure'
                },
            },

            // 设施设备
            {
                path: 'equipmentAndFacilities',
                name: 'equipmentAndFacilities',
                component: () => import(`@/${BASE_PATH_CATEGORY}/equipmentAndFacilities/EquipmentAndFacilities.vue`),
                meta: {
                    index: '1-4',
                },
            },
            {
                path: 'equipmentAndFacilities-large',
                name: 'equipmentAndFacilitiesLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-4',
                    type:'设施设备',
                    routerBack:'equipmentAndFacilities'
                },
            },

            // 综合防治对象
            {
                path: 'integratedControlTargets',
                name: 'integratedControlTargets',
                component: () => import(`@/${BASE_PATH_CATEGORY}/integratedControlTargets/IntegratedControlTargets.vue`),
                meta: {
                    index: '1-5',
                },
            },
            {
                path: 'integratedControlTargets-large',
                name: 'integratedControlTargetsLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-5',
                    type:'综合防治对象',
                    routerBack:'integratedControlTargets'
                },
            },

            // 污染源
            {
                path: 'pollutionSources',
                name: 'pollutionSources',
                component: () => import(`@/${BASE_PATH_CATEGORY}/pollutionSources/PollutionSources.vue`),
                meta: {
                    index: '1-6',
                },
            },
            {
                path: 'pollutionSources-large',
                name: 'pollutionSourcesLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-6',
                    type:'污染源',
                    routerBack:'pollutionSources'
                },
            },

            // 饲料
            {
                path: 'fodder',
                name: 'fodder',
                component: () => import(`@/${BASE_PATH_CATEGORY}/fodder/Fodder.vue`),
                meta: {
                    index: '1-7',
                },
            },
            {
                path: 'fodder-large',
                name: 'fodderLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-7',
                    type:'饲料',
                    routerBack:'fodder'
                },
            },

            // 物联网信息类型
            {
                path: 'informationTypes',
                name: 'informationTypes',
                component: () => import(`@/${BASE_PATH_CATEGORY}/informationTypes/InformationTypes.vue`),
                meta: {
                    index: '1-8',
                },
            },
            {
                path: 'informationTypes-large',
                name: 'informationTypesLarge',
                component: () => import(`@/${BASE_PATH}/LargeManagement.vue`),
                meta: {
                    index: '1-8',
                    type:'物联网信息类型',
                    routerBack:'informationTypes'
                },
            },
        ],
    },
];
export default dataManagement;